module.exports = __webpack_public_path__ + "static/media/logo-comprasrj.00170a80.png";